import {useNavigate} from "react-router-dom";
import {EditStoreServiceFormValues} from "../types";
import {message} from "antd";
import {editStoreServiceDto} from "../edit-store-service-service";
import {useUpdateStoreServiceApi} from "../../../../react-query-hooks/store/services/update-store-service";

interface HookResult {
  editStoreService(values: EditStoreServiceFormValues): void;
  wasStoreServiceEdited: boolean;
  isEditingStoreService: boolean;
  responseData?: any;
}

export function useEditStoreServiceHook(): HookResult {
  const navigate = useNavigate();
  const editStoreServiceMutation = useUpdateStoreServiceApi();

  const editStoreService = (values: EditStoreServiceFormValues) => {
    editStoreServiceMutation.mutate(editStoreServiceDto(values), {
      onSuccess() {
        message.success("Updated Successfully");
        navigate("/products?activeTab=services");
      },
    });
  };
  return {
    editStoreService,
    wasStoreServiceEdited: editStoreServiceMutation.isSuccess,
    isEditingStoreService: editStoreServiceMutation.isLoading,
    responseData: editStoreServiceMutation.isSuccess
      ? editStoreServiceMutation.data.data
      : undefined,
  };
}
